export enum DateRangeTemplateType {
  YESTERDAY = 'YESTERDAY',
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW',
  THIS_WEEK = 'THIS_WEEK',
  CALENDAR_WEEK = 'CALENDAR_WEEK',
  LAST_WEEK = 'LAST_WEEK',
  NEXT_WEEK = 'NEXT_WEEK',
  PAST_WEEK = 'PAST_WEEK',
  THIS_MONTH = 'THIS_MONTH',
  CALENDAR_MONTH = 'CALENDAR_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  NEXT_MONTH = 'NEXT_MONTH',
  THIS_YEAR = 'THIS_YEAR',
  PAST_YEAR = 'PAST_YEAR',
  PREVIOUS_YEAR = 'PREVIOUS_YEAR'
}
